/* eslint-disable @typescript-eslint/no-explicit-any */
import { safeJsonParse } from "@/zapi-frontend/utils/safeJsonParse";
import { MAX_CHAT_HISTORY_LENGTH } from "../../const/consts";
import { removeContentFromResponse } from "@/zapi-frontend/widgets/ChatIsland/lib/removeContentFromResponse";

function cleanChatMessages(messages: any[]) {
  return messages.map((message) => {
    if (message.role === "user" || !message.content.includes("updateChapter")) return message;
    return {
      ...message,
      content: removeContentFromResponse(message.content)
    };
  });
}

export function transformChatStorage(value: string | null): string | null {
  if (!value) return null;
  try {
    const v = safeJsonParse(value, {});
    const chatHistory = v?.state?.chatHistory;
    if (!chatHistory) return null;

    const cleanedChat = Object.fromEntries(
      Object.entries(chatHistory).map(([key, value]) => [
        key,
        cleanChatMessages((value as any[]).slice(-MAX_CHAT_HISTORY_LENGTH))
      ])
    );
    return JSON.stringify({
      ...v,
      state: {
        ...v.state,
        chatHistory: cleanedChat
      }
    });
  } catch (error) {
    console.error("Error transforming chat storage:", error);
    return value;
  }
}
